import type { ILeadFormRules } from '@/interfaces/forms';

/**
 * Which lead-form fields are mandatory for this visitor. Phone is always
 * required (sales call back); LINE ID only where LINE is the channel they will
 * actually be contacted on — Taiwan (CloudFront country 'TW', same rule as
 * `isTaiwanVisitor`). Everyone else can leave it blank.
 */
export function leadFormRules(countryCode: string | null): ILeadFormRules {
  return { phoneRequired: true, lineIdRequired: countryCode === 'TW' };
}

/**
 * Loose phone check: an optional leading "+", then 7–15 digits once spaces,
 * dashes, dots and brackets are ignored. Accepts "0912 345 678", "+886-2-1234-5678",
 * "(02) 1234 5678"; rejects words, emails and short numbers.
 */
export function isPlausiblePhone(value: string): boolean {
  const trimmed = value.trim();
  if (!/^\+?[\d\s().-]+$/.test(trimmed)) return false;
  const digits = trimmed.replace(/\D/g, '');
  return digits.length >= 7 && digits.length <= 15;
}
